"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionsPropTypes = exports.validationPropsTypes = exports.getValidationProps = exports.shouldIconDisplay = exports.shouldMessageDisplay = exports.isFieldVisiblyInvalid = exports.getFieldValidationMessage = exports.getFieldValidType = exports.showMaxLengthCounter = exports.getAllFieldElementIds = exports.boolToString = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconConst = require("../icons/iconConst");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var INPUT_SUFFIX = 'input';
var LABEL_SUFFIX = 'input-label';
var HELPER_SUFFIX = 'input-helper';
var COUNTER_SUFFIX = 'input-counter';
var VALIDATION_SUFFIX = 'input-validation';
var ICON_SUFFIX = 'input-icon'; // in this html markup we want strings for our booleans

var boolToString = function boolToString(bool) {
  return bool ? 'true' : 'false';
};

exports.boolToString = boolToString;

var makeElementId = function makeElementId(name, suffix) {
  return {
    id: "".concat(name, "-").concat(suffix)
  };
};
/**
 * Generate IDs for fields to be dynamically related to each other
 * not all of these elements are always present in the DOM
 * make the components responsible how/if/when they relate
 * to each other for ARIA attributes
 *
 * @param  {String} name - the name of the field
 * @return {Object} - the Ids for elements
 */


var getAllFieldElementIds = function getAllFieldElementIds(name) {
  return {
    input: makeElementId(name, INPUT_SUFFIX),
    label: makeElementId(name, LABEL_SUFFIX),
    helper: makeElementId(name, HELPER_SUFFIX),
    counter: makeElementId(name, COUNTER_SUFFIX),
    icon: makeElementId(name, ICON_SUFFIX),
    validation: makeElementId(name, VALIDATION_SUFFIX)
  };
};
/**
 * True or false whether to show the Max Length Counter.
 *
 * @param  {string} inputValue - the value from the input
 * @param  {Number} maxLength - the maxLength of the input
 * @return {boolean}
 */


exports.getAllFieldElementIds = getAllFieldElementIds;

var showMaxLengthCounter = function showMaxLengthCounter(inputValue, maxLength) {
  var length = inputValue ? inputValue.length : 0;
  return length >= maxLength - 5;
};
/**
 * Get one of (ERROR, WARNING or VALID) depending on the validation status of the field.
 *
 * @param  {boolean} isInvalid - whether the field is valid or not
 * @param  {String} warningMessage - the warning message if applicable
 * @param  {boolean} [showCounter=false] (optional)
 * @return {String} the current state of field validation: ERROR or WARNING or VALID
 */


exports.showMaxLengthCounter = showMaxLengthCounter;

var getFieldValidType = function getFieldValidType(isInvalid, warningMessage) {
  var showCounter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isInvalid) return _iconConst.ERROR;
  if (warningMessage || showCounter) return _iconConst.WARNING;
  return _iconConst.VALID;
};
/**
 * One message at a time -> prioritize error over warnings
 *
 * @param  {boolean} isInvalid - whether the field is valid or not
 * @param  {String} [warningMessage] - (optional) the warning message if applicable
 * @param  {String} [errorMessage] - (optional) the error message if applicable
 * @return {String} translated message to be displayed
 */


exports.getFieldValidType = getFieldValidType;

var getFieldValidationMessage = function getFieldValidationMessage(isInvalid, warningMessage, errorMessage) {
  var type = getFieldValidType(isInvalid, warningMessage);

  if (type === _iconConst.ERROR && errorMessage) {
    return errorMessage;
  }

  if (type === _iconConst.WARNING && warningMessage) {
    return warningMessage;
  }

  return null;
};
/**
 * True or false as to whether the field meets the criteria for displaying as invalid.
 *
 * @param  {boolean} [isInvalid=false] - (optional) whether the field is valid or not
 * @param  {boolean} [isTouched=false] - (optional) whether the field has been interacted with or not
 * @param  {boolean} [showUntouchedErrors=false] - (optional) whether or not to show errors
 *                                                  on fields that have not been touched
 * @return {boolean} whether the field has been interacted with and is invalid
 */


exports.getFieldValidationMessage = getFieldValidationMessage;

var isFieldVisiblyInvalid = function isFieldVisiblyInvalid() {
  var isInvalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isTouched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var showUntouchedErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return isInvalid && (isTouched || showUntouchedErrors) || false;
};
/**
 * True or false as to whether the field meets criteria for displaying an error or warning.
 *
 * This checks for whether the field is invalid and has been interacted with (when we care based on showUntouchedErrors)
 * OR there is a warning message provided (therefore don't wait for the field to be touched)
 *
 * @param  {boolean} [isInvalid=false] - (optional) whether the field is valid or not
 * @param  {boolean} [isTouched=false] - (optional) whether the field has been interacted with or not
 * @param  {boolean} [showUntouchedErrors=false] - (optional) whether or not to show errors
 *                                                  on fields that have not been touched
 * @param  {String} [warningMessage] - (optional) the warning message if applicable
 * @return {boolean} whether to show error or warning message
 */


exports.isFieldVisiblyInvalid = isFieldVisiblyInvalid;

var shouldMessageDisplay = function shouldMessageDisplay() {
  var isInvalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isTouched = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var showUntouchedErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var warningMessage = arguments.length > 3 ? arguments[3] : undefined;
  return isFieldVisiblyInvalid(isInvalid, isTouched, showUntouchedErrors) || !!warningMessage;
};
/**
 * True or false whether the field meets the criteria for displaying a validation icon.
 *
 * This checks for whether the field has been interacted with so we don't
 * show an icon on an empty and valid(optional) field.
 *
 * @param  {string|undefined}  inputValue - the value of the field
 * @param  {boolean} [isValid=false] - (optional) whether the field is valid or not
 * @param  {boolean} [isTouched=false] - (optional) whether the field has been interacted with or not
 * @param  {boolean} [showCounter=false] - (optional) whether the field has a maxLength counter
 * @return {boolean}
 */


exports.shouldMessageDisplay = shouldMessageDisplay;

var shouldIconDisplay = function shouldIconDisplay(inputValue) {
  var isValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isTouched = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var showCounter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var inputLength = inputValue ? inputValue.length : 0;
  var isEmptyAndValid = inputLength === 0 && isValid;
  return isTouched && !isEmptyAndValid || showCounter;
};
/**
 * Get a set of properties helping describe the validation state of the field from a
 * UI perspective (i.e. whether to show a message, icon, type of icon, etc)
 *
 * @param  {string} inputValue - the value of the field
 * @param  {boolean} [isInvalid] - (optional) whether the field is valid or not
 * @param  {boolean} [isTouched] - (optional) whether the field has been interacted with or not
 * @param  {String} [warningMessage] - (optional) the warning message if applicable
 * @param  {String} [errorMessage] - (optional) the error message if applicable
 * @param  {boolean} [showCounter=false] - (optional) whether the field has a maxLength counter
 * @param  {boolean} [showUntouchedErrors=false] - (optional) whether or not to show errors
 *                                                       on fields that have not been touched
 * @return {Object} object with the following shape:
 *      isInvalid - @see isFieldVisiblyInvalid
 *      showMessage - @see shouldMessageDisplay
 *      showIcon - @see shouldIconDisplay
 *      type - @see getFieldValidType
 *      message - @see getFieldValidationMessage
 */


exports.shouldIconDisplay = shouldIconDisplay;

var getValidationProps = function getValidationProps(inputValue, isInvalid, isTouched, warningMessage, errorMessage) {
  var showCounter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var showUntouchedErrors = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  return {
    isInvalid: isFieldVisiblyInvalid(isInvalid, isTouched, showUntouchedErrors),
    showMessage: shouldMessageDisplay(isInvalid, isTouched, showUntouchedErrors, warningMessage),
    showIcon: shouldIconDisplay(inputValue, !isInvalid, isTouched, showCounter),
    type: getFieldValidType(isInvalid, warningMessage, showCounter),
    message: getFieldValidationMessage(isInvalid, warningMessage, errorMessage)
  };
};
/* the shape of validationProps data passed in to many of the components */


exports.getValidationProps = getValidationProps;

var validationPropsTypes = _propTypes.default.shape({
  isInvalid: _propTypes.default.bool.isRequired,
  showMessage: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  type: _propTypes.default.string.isRequired,
  message: _propTypes.default.string
});
/* the shape of options data passed to an InputAutocompleteGroup, SelectGroup or TabList */


exports.validationPropsTypes = validationPropsTypes;

var optionsPropTypes = _propTypes.default.arrayOf(_propTypes.default.shape({
  // eslint-disable-next-line consistent-return
  value: function value(props, propName, componentName) {
    var prop = props[propName];

    var propType = _typeof(prop);

    if (propType !== 'string' && propType !== 'number' && prop !== null) {
      return new Error("The prop '".concat(propName, "' supplied to '").concat(componentName, "' must be either") + " a string, number, or null, but its value is '".concat(prop, "'."));
    }
  },
  label: _propTypes.default.string.isRequired
}));

exports.optionsPropTypes = optionsPropTypes;